import type { BatchPreviewState, BatchPreviewType } from "./batch-preview.type";

import { useSearchParams } from "react-router";

import { useGetUser } from "@/entities/user";
import { getIntValue } from "@/utilities/number";

import { getBatchPreviewIds } from "./batch-preview.helper";

export const useBatchPreviewTypeParam = () => {
  const [searchParams] = useSearchParams();

  const type = searchParams?.get("type");

  return type ? (type as BatchPreviewType) : undefined;
};

export const useBatchPreviewStateParam = <
  State extends BatchPreviewState = BatchPreviewState,
>() => {
  const [searchParams] = useSearchParams();

  return (searchParams?.get("state") ?? "") as State;
};

export const useBatchPreviewIdsParam = () => {
  const [searchParams] = useSearchParams();

  const idsParam = searchParams?.get("ids") ?? "";
  const ids = getBatchPreviewIds(idsParam);

  return { ids, idsParam };
};

export const useBatchPreviewNumberParam = (key: string) => {
  const [searchParams] = useSearchParams();

  const value = searchParams?.get(key);

  return getIntValue(value ?? "");
};

export const useBatchPreviewGetUserData = (key = "user_id") => {
  const userId = useBatchPreviewNumberParam(key);
  const { user, isLoading } = useGetUser(userId);

  return {
    userName: user?.name,
    userLoading: isLoading,
  };
};
